export default __webpack_public_path__ + "static/media/document.6993fb7d.svg";